module.exports = __webpack_public_path__ + "img/BarryAsh.07b19552.jpg";